import { createSlice } from '@reduxjs/toolkit';

const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    checked: false,
    authenticated: false,
    profile: null,
  },
  reducers: {
    setSession(state, action) {
      state.checked = true;
      state.authenticated = true;
      state.profile = action.payload;
    },
    clearSession(state) {
      state.checked = true;
      state.authenticated = false;
      state.profile = null;
    },
    setSessionChecked(state) {
      state.checked = true;
    },
  },
});

export const { setSession, clearSession, setSessionChecked } = sessionSlice.actions;
export default sessionSlice.reducer;
